/**
 * Determines whether a given Link should not be displaying in Site map
 * based on its categoryId and URL.
 *
 * @param {Object} item - The item to evaluate.
 * @param {string} item.categoryId - The category ID of the item.
 * @param {string} [item.url] - The URL of the item (optional).
 * @returns {boolean} `true` if the item should be skipped, otherwise `false`.
 */
const skipSiteMapLink = (item) => item.categoryId === 'siteMap' || (item.categoryId === 'personalInfo' && !item.url);

export default skipSiteMapLink;
